import styled from 'styled-components';

const RichTextImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  position: relative;
  ${({ justifyDesktop, justifyMobile }) => {
    if (justifyDesktop || justifyMobile) {
      return `display: flex;
              justify-content: ${justifyMobile || justifyDesktop} !important;
        `;
    }
  }}

  .rich-text-image--image {
    width: auto;
    height: auto;
    display: block;
    margin: 10px auto;
  }

  .rich-text-image--caption {
    margin: 10px 0;
    padding: 0;
    font-size: var(--font-size-16) !important;
    color: var(--dark);
  }

  .img--link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`;

export { RichTextImageContainer };
